import { useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import { Box, Grid, FormControl, Select, MenuItem, InputLabel } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TextInput from '../common/formControls/TextInput';
import { camelToTitle } from '../../utils/Functions';

const UnitStatus = (props: ChildProps) => {
  const { title, disabled, code, color, numberIndex, handleDelete, handleStatusInput, statusDispatch, statusType, category } = props;
  const [showColor, setShowColor] = useState(false);
  const [colorful, setColorful] = useState('');

  const handleColorPicker = () => {
    setShowColor(!showColor);
  };

  const handleColorPickerBlur = (e: any) => {
    setShowColor(!showColor);
  };

  const handleHexColor = (e: any) => {
    statusDispatch({ type: 'UPDATE', payload: { index: numberIndex, field: 'color', value: e } });
    setColorful(e);
  };

  return (
    <>
      <Grid sx={{ mt: 2 }} item xs={12} sm={2}>
        <TextInput
          title={'Status Title'}
          name={`name`}
          value={title}
          disabled={disabled}
          handleTextInput={(e: HTMLInputElement) => handleStatusInput(e, numberIndex)}
        />
      </Grid>
      <Grid sx={{ mt: 2 }} item xs={12} sm={2}>
        <TextInput
          title={'Status Code'}
          name={'code'}
          value={code}
          disabled={disabled}
          handleTextInput={(e: HTMLInputElement) => handleStatusInput(e, numberIndex)}
        />
      </Grid>
      <Grid
        sx={{
          position: 'relative',
          marginTop: '20px',
        }}
        item
        xs={12}
        sm={2}
      >
        {showColor ? (
          <Box
            sx={{
              position: 'absolute',
              zIndex: 100,
              top: '80px',
            }}
          >
            <HexColorPicker color={colorful} onChange={(e) => handleHexColor(e)} />
          </Box>
        ) : null}
        <TextInput
          background={color}
          title={'Color'}
          handleTextInput={(e: HTMLInputElement) => handleStatusInput(e, numberIndex)}
          name={'color'}
          value={color}
          disabled={disabled}
          focus={true}
          blur={true}
          handleFocus={handleColorPicker}
          handleBlur={(e: any) => handleColorPickerBlur(e)}
        />
      </Grid>
      <Grid sx={{ mt: 2 }} item xs={12} sm={!disabled ? 2 : 3}>
        <FormControl fullWidth>
          <InputLabel id="id-question-label">Status Type</InputLabel>
          <Select
            value={statusType}
            labelId="id-status-type"
            id="status-type"
            label="Status Type"
            name="type"
            onChange={(e) => handleStatusInput(e, numberIndex)}
          >
            {['preconstruction', 'leasing'].map((type: string) => {
              return <MenuItem value={type}>{camelToTitle(type)}</MenuItem>;
            })}
          </Select>
        </FormControl>
      </Grid>
      <Grid sx={{ mt: 2 }} item xs={12} sm={!disabled ? 2 : 3}>
        <FormControl fullWidth>
          <InputLabel id="id-category-label">Category</InputLabel>
          <Select
            value={category || ''}
            labelId="id-category-label"
            id="category"
            label="Category"
            name="category"
            disabled={disabled}
            onChange={(e) => handleStatusInput(e, numberIndex)}
          >
            {['inventory', 'sales'].map((categoryOption: string) => {
              return <MenuItem value={categoryOption}>{camelToTitle(categoryOption)}</MenuItem>;
            })}
          </Select>
        </FormControl>
      </Grid>
      {!disabled ? (
        <Grid
          sx={{
            display: 'flex',
            alignSelf: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            mt: 2,
          }}
          item
          xs={12}
          sm={1}
        >
          <CloseIcon color="secondary" onClick={() => handleDelete(numberIndex)} />
        </Grid>
      ) : null}
    </>
  );
};

interface ChildProps {
  type: string;
  key: number;
  numberIndex: number;
  value: string;
  title: string;
  code: string;
  statusType: string;
  category?: string;
  color: string;
  disabled: boolean;
  handleStatusInput?: any;
  handleDelete?: any;
  handleColorInput?: any;
  statusDispatch?: any;
}

export default UnitStatus;
